import { useTranslation } from "react-i18next";
import useSetPageTitle from "utilities/useSetPageTitle";
import { SubscriptionsAndPricingShop } from "./Shop/Shop";

export const SubscriptionsAndPricing = () => {
  const { t } = useTranslation();
  useSetPageTitle({
    title: t('SubscriptionsAndPricing', { ns: 'subscriptionsAndPricing' }),
    subtitle: t('Description', { ns: 'subscriptionsAndPricing' }),
  });
  return <SubscriptionsAndPricingShop />;
}